import React from 'react';
import { Box, Tabs, Tab, useTheme, Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { pageHorizontalPadding } from '../Layout/Layout';

const HeaderTabs = ({ tabs = [], activeTab = 0, onTabChange = () => {}, showTabs = true }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  if (!showTabs || tabs.length === 0) return null;

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.background.tabs,
        borderBottom: `1px solid ${theme.palette.divider}`,
        paddingTop: theme.spacing(2),
        paddingBottom: 0,
      }}
    >
      <Container maxWidth={false} disableGutters sx={{ paddingX: pageHorizontalPadding }}>
        <Tabs
          value={activeTab}
          onChange={(_, newValue) => onTabChange(newValue)}
          variant="scrollable"
          scrollButtons="auto"
          allowScrollButtonsMobile
          sx={{
            minHeight: '56px',
            '& .MuiTabs-indicator': {
              backgroundColor: theme.palette.primary.main,
              height: '2px',
            },
            '& .MuiTab-root': {
              color: theme.palette.text.secondary,
              textTransform: 'none',
              fontWeight: theme.typography.fontWeightMedium,
              fontSize: theme.typography.body2.fontSize,
              padding: { xs: `${theme.spacing(2)} ${theme.spacing(1)}`, md: `${theme.spacing(2)} ${theme.spacing(2)}` },
              minWidth: 'auto',
              marginRight: { xs: theme.spacing(1.5), md: theme.spacing(3) },
              minHeight: '56px',
              '&.Mui-selected': {
                color: theme.palette.primary.main,
                fontWeight: theme.typography.fontWeightBold,
              },
            },
          }}
        >
          {tabs.map((tab, index) => (
            <Tab key={index} label={t(tab.labelKey || tab.label.toLowerCase())} />
          ))}
        </Tabs>
      </Container>
    </Box>
  );
};

export default HeaderTabs; 